import {
  getOcpc,
  setOcpc,
  getOcpcRecordListDatas,
  getOcpcstatistiData,
  getOcpcSetListDatas,
  closeOcpc,
  openOcpc

} from '@/services/config'
import i18n from '@/lib/language'
export default {
  namespaced: true,
  state: {
    submitting: false,
    datasReady: false,
    datas: {
    },
    config: {},
    form: '',
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 50],
      total: 0
    },
    // 推送记录title
    sendListColumns: [
      {
        key: 'inquirycode',
        title: i18n.t('message["1831"]'),
        dataIndex: 'inquirycode',
        width: 150
      },
      {
        key: 'adid',
        title: i18n.t('message["1832"]'),
        dataIndex: 'adid',
        width: 280
      },
      {
        title: i18n.t('message["1835"]'),
        dataIndex: 'type',
        key: 'type',
        slots: { title: 'type' },
        scopedSlots: {
          filterDropdown: 'filterDropdownChannel',
          customRender: 'type',
          filterIcon: 'filterIcon'
        },
        // filterIcon: '<em class="th-filter-icon anticon anticon-filter"><i class="iconfont iconicon-test20"></i></em>',
        width: 130,
        ellipsis: true
      },
      {
        title: i18n.t('message["1836"]'),
        dataIndex: 'uptime',
        key: 'uptime',
        slots: { title: 'uptime' },
        scopedSlots: { customRender: 'uptime' },
        width: 214,
        sorter: true
      },
      {
        title: i18n.t('message["1837"]'),
        dataIndex: 'status',
        key: 'status',
        slots: { title: 'status' },
        scopedSlots: {
          filterDropdown: 'filterDropdown',
          customRender: 'status',
          filterIcon: 'filterIcon2'
        },
        width: 140
      },
      {
        title: i18n.t('message["79"]'),
        dataIndex: 'recordid',
        key: 'recordid',
        slots: { title: 'recordid' },
        scopedSlots: { customRender: 'operate' }
      }
    ],
    ocpcStatistiData: {},
    recordTableDatas: [
    ],
    // setlist columns
    setListColumns: [
      {
        title: i18n.t('message["1835"]'),
        dataIndex: 'type',
        key: 'type',
        slots: { title: 'type' },
        scopedSlots: { customRender: 'type' },
        width: 150
      },
      {
        title: i18n.t('message["1837"]'),
        dataIndex: 'status',
        key: 'status',
        slots: { title: 'statusType' },
        scopedSlots: { customRender: 'status' }
      },
      {
        title: i18n.t('message["79"]'),
        dataIndex: 'recordid',
        key: 'recordid',
        slots: { title: 'recordid' },
        scopedSlots: { customRender: 'operate' },
        width: 100
      }
    ],
    statusType: [
      i18n.t('message["1879"]'),
      i18n.t('message["1880"]'),
      i18n.t('message["1881"]')
    ],
    // 渠道类型
    channelType: [
      i18n.t('message["1827"]'),
      'Google',
      'Yandex'
    ],
    isRecordDataReady: false,
    setListDatas: {},
    isConfig: true
  },
  getters: {
    setListTableDatas (state) {
      const { setListDatas = {} } = state
      let listArr = []
      for (let key in setListDatas) {
        const item = setListDatas[key]
        listArr.push({
          key: key,
          type: key,
          status: item.status,
          token: item.token
        })
      }
      return listArr
    }
  },
  mutations: {
    // 设置数据容器的值
    setDatas (state, datas) {
      state.datas = datas.data
      state.config = datas.config
    },
    setSubmitting (state, type) {
      state.submitting = type
    },
    setPageTotal (state, data) {
      state.pagination.total = data
      // state.pagination.currentPage = 1
    },
    setOcpcStatistiData (state, data) {
      state.ocpcStatistiData = data
    },
    setRecordTableDatas (state, data) {
      state.recordTableDatas = data
    },
    setIsRecordDataReady (state, b) {
      state.isRecordDataReady = b
    },
    setSetListDatas (state, data) {
      state.setListDatas = data
    },
    setIsConfig (state, b) {
      state.isConfig = b === 1
    },
    setdatasReady (state, b) {
      state.datasReady = b
    }
  },
  actions: {
    async fetchSetDatas ({ commit }, datas) {
      commit('setdatasReady', false)
      const chain = await getOcpc()
        .params(datas)
        .onSuccess((raw) => {
          commit('setDatas', raw)
          commit('setdatasReady', true)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 获取ocpc统计数据
    async getOcpcstatistiData ({ commit }) {
      const chain = await getOcpcstatistiData()
        .onSuccess((raw) => {
          commit('setOcpcStatistiData', raw)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 获取ocpc推送列表数据
    async getOcpcRecordListDatas ({ commit }, data) {
      commit('setIsRecordDataReady', false)
      const chain = await getOcpcRecordListDatas()
        .params(data)
        .onSuccess((raw) => {
          commit('setRecordTableDatas', raw.list)
          commit('setPageTotal', parseInt(raw.count))
          commit('setIsConfig', raw.is_config)
          commit('setIsRecordDataReady', true)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 获取ocpc设置列表数据
    async getOcpcSetListDatas ({ commit }) {
      commit('setIsRecordDataReady', false)
      const chain = await getOcpcSetListDatas()
        .onSuccess((raw) => {
          commit('setSetListDatas', raw)
          commit('setIsRecordDataReady', true)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    async openCloseOcpc ({ commit }, data) {
      let openCloseOcpc = data.isOpen ? openOcpc : closeOcpc
      const chain = await openCloseOcpc()
        .params({ type: data.type })
        .onSuccess((raw) => {
        })
        .config({ tip: true })
        .fetch()
      return chain
    },
    async setOcpc ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await setOcpc()
        .onSuccess(async () => {
          // const res = await dispatch('fetchCollectDatas', type)
          // res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        // .config({ tip: false })
      return chain
    }
  }
}
